import { APIPost, APIGet } from './http';
import { IUser, ILoginCreds, IAuthResult, AuthenticationOptions, IChangeCredentialResult, ChangeCredentialResultOptions } from '../_types/user';
import { IFetchData } from '../_types/post';
import { IPolicyObject, PolicyObjectTypeOptions } from '../_types/ewpolicy';


export const ServerTestMode = async (): Promise<boolean> => {

    let toReturn: boolean = false;

    let request: IFetchData = {
        
        relay_to: "/auth/servertestmode",
        method: "GET",
        authorize: false,
        service: "ewapi",
        refresh: false
    };

    toReturn = await APIGet(request) || false;
    

    
    return toReturn;

}

/*
This gets the current user from the cookie (shared with dashboard), in a form that
this app can digest. This assumes that the user landed here via link from the existing dashboard.
*/
export const GetMe = async (): Promise<IUser | null> => {


    let toReturn: IUser | null = null;

    let request: IFetchData = {
        
        relay_to: "/auth/getme",
        method: "GET",
        authorize: true,
        service: "ewapi",
        refresh: true
    };

    toReturn = await APIGet(request);
    

    if (toReturn) {

        (toReturn as IPolicyObject).policies = [];
        (toReturn as IPolicyObject).objectType = PolicyObjectTypeOptions.user;

  

        if (toReturn.locations && toReturn.locations.length === 1) {
            toReturn.currentLocation = toReturn.locations[0];
        }

        toReturn.authorized = true;
        toReturn.fromCookie = true;
    } else {
        toReturn = { fromCookie: false, authorized: false, objectType: PolicyObjectTypeOptions.user };
    }
    
    
    return toReturn;

}


export const ObliterateMe = async(id: number): Promise<boolean> => {

    let toReturn: boolean = true;

    let postData: IFetchData = { 
        method: "GET", 
        relay_to: `/User/ObliterateUser/${id}`, 
        authorize: true,
        service: "ewapi",
        refresh: true  
    };

    //if successful, will set session cookie, jwt after post
    await APIPost(postData);

    toReturn = true;

    //we 
    //login with username/password.  If 

    return toReturn;

}

export const Login = async(creds: ILoginCreds): Promise<IUser | null> => {

    let toReturn: IUser | null = null;

    let postData: IFetchData = { 
        method: "POST", 
        relay_to: "/auth", 
        authorize: false,
        refresh: false,
        service: "ewapi",
        provider: "authprovider.userdefined",
        requestToken: true,
        ...creds,  }

    //if successful, will set session cookie, jwt after post
    await APIPost(postData);

    toReturn = await GetMe();

    //we 
    //login with username/password.  If 

    return toReturn;

}


export const CheckForEmail = async(email: string): Promise<IAuthResult> => {

    let fromAPI: IAuthResult | null = null;
    let toReturn: IAuthResult = {
        result: AuthenticationOptions.NoMatch,
        user_id: null
    };

    let toPost = {
        provider: "authprovider.userdefined",
        token: email,
        requestToken: false
    };

    let postData: IFetchData = { 
        method: "POST", 
        relay_to: "/auth/testcredential", 
        authorize: false,
        service: "ewapi",
        refresh: false,
        ...toPost
     }

    //if successful, will set session cookie, jwt after post
    fromAPI = await APIPost<IAuthResult>(postData);

    if (fromAPI) {
        toReturn = fromAPI;
    }
    

    //we 
    //login with username/password.  If 

    return toReturn;

}

export const CreateEmail = async(user_id: number, email: string): Promise<IChangeCredentialResult> => {

    let fromAPI: IChangeCredentialResult | null = null;
    let toReturn: IChangeCredentialResult = {
        result: ChangeCredentialResultOptions.Unknown,
        credential: null
    };


    let toPost = {
        provider: "authprovider.userdefined",
        user_id: user_id,
        Token: email
    };

    let postData: IFetchData = { 
        method: "POST", 
        relay_to: "/auth/setcredential", 
        authorize: true,
        service: "ewapi",
        refresh: true,
        ...toPost
     }

    //if successful, will set session cookie, jwt after post
    fromAPI = await APIPost<IChangeCredentialResult>(postData);

    if (fromAPI) {
        toReturn = fromAPI;
    }
    

    //we 
    //login with username/password.  If 

    return toReturn;

}